/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';
import type { EListSearchTypeEStatutDemandeCombinableCriteria } from './EListSearchTypeEStatutDemandeCombinableCriteria';
import {
    EListSearchTypeEStatutDemandeCombinableCriteriaFromJSON,
    EListSearchTypeEStatutDemandeCombinableCriteriaFromJSONTyped,
    EListSearchTypeEStatutDemandeCombinableCriteriaToJSON,
} from './EListSearchTypeEStatutDemandeCombinableCriteria';
import type { EStatutDemande } from './EStatutDemande';
import {
    EStatutDemandeFromJSON,
    EStatutDemandeFromJSONTyped,
    EStatutDemandeToJSON,
} from './EStatutDemande';

/**
 * 
 * @export
 * @interface EStatutDemandeListSearch
 */
export interface EStatutDemandeListSearch {
    /**
     * 
     * @type {Array<EListSearchTypeEStatutDemandeCombinableCriteria>}
     * @memberof EStatutDemandeListSearch
     */
    criterias?: Array<EListSearchTypeEStatutDemandeCombinableCriteria> | null;
    /**
     * 
     * @type {EListSearchType}
     * @memberof EStatutDemandeListSearch
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {EStatutDemande}
     * @memberof EStatutDemandeListSearch
     */
    value?: EStatutDemande;
    /**
     * 
     * @type {EStatutDemande}
     * @memberof EStatutDemandeListSearch
     */
    secondaryValue?: EStatutDemande;
    /**
     * 
     * @type {Array<string>}
     * @memberof EStatutDemandeListSearch
     */
    readonly availableSearchTypes?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof EStatutDemandeListSearch
     */
    defaultSearchType?: string | null;
}

/**
 * Check if a given object implements the EStatutDemandeListSearch interface.
 */
export function instanceOfEStatutDemandeListSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EStatutDemandeListSearchFromJSON(json: any): EStatutDemandeListSearch {
    return EStatutDemandeListSearchFromJSONTyped(json, false);
}

export function EStatutDemandeListSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): EStatutDemandeListSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criterias': !exists(json, 'criterias') ? undefined : (json['criterias'] === null ? null : (json['criterias'] as Array<any>).map(EListSearchTypeEStatutDemandeCombinableCriteriaFromJSON)),
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : EStatutDemandeFromJSON(json['value']),
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : EStatutDemandeFromJSON(json['secondaryValue']),
        'availableSearchTypes': !exists(json, 'availableSearchTypes') ? undefined : json['availableSearchTypes'],
        'defaultSearchType': !exists(json, 'defaultSearchType') ? undefined : json['defaultSearchType'],
    };
}

export function EStatutDemandeListSearchToJSON(value?: EStatutDemandeListSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criterias': value.criterias === undefined ? undefined : (value.criterias === null ? null : (value.criterias as Array<any>).map(EListSearchTypeEStatutDemandeCombinableCriteriaToJSON)),
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': EStatutDemandeToJSON(value.value),
        'secondaryValue': EStatutDemandeToJSON(value.secondaryValue),
        'defaultSearchType': value.defaultSearchType,
    };
}

